import { TemplateTextFont } from "@jackfruit/common"
import { createEntitySlice } from "../createEntitySlice"

export const {
  slice: templateTextFonts,
  selectors: templateTextFontsSelector,
} = createEntitySlice<TemplateTextFont>("templateTextFonts")
